import { useState } from 'react'
import type { Shop, ShopSale } from '@mezha/api'
import { useSellMutation } from '../../api/endpoints/trade'
import { useCommand } from '../../lib/useCommand'
import { ConfirmInPlace, PlankButton } from '../../ui'
import { ItemArt, silverText, modList } from '../common'

/** A sale always identifies an inventory instance and confirms the visible quote. */
export function SellPanel({ shop, refetch }: { shop: Shop; refetch: () => void }) {
  const [sell] = useSellMutation()
  const cmd = useCommand(refetch, refetch)
  const [done, setDone] = useState('')
  const entries = shop.sellables ?? []
  const submit = async (e: ShopSale, quantity: number) => {
    setDone('')
    const result = await cmd.run(() => sell({ shop_id: shop.id, expected_version: shop.version, entry_id: e.entry_id, quantity, unit_price: e.price }).unwrap())
    if (result) setDone(`Продано: ${e.item.name} ×${quantity}. Получено ${silverText(e.price * quantity)}.`)
  }
  return <div className="sell-panel">
    <p>Выберите вещи из сумы. Надетые и сюжетные вещи не продаются. Материалы могут понадобиться для ремесла.</p>
    <p>У вас {silverText(Number(shop.silver))}.</p>
    {cmd.text && <p role="alert">{cmd.text}</p>}
    {done && <p role="status">{done}</p>}
    {!entries.length && <p>В суме пока нет вещей для продажи.</p>}
    <div className="sell-list">{entries.map(e => <SaleCard key={`${e.entry_id}-${e.quantity}-${e.price}-${e.block}`} entry={e} onSell={n => submit(e, n)} />)}</div>
  </div>
}

function SaleCard({ entry: e, onSell }: { entry: ShopSale; onSell: (quantity: number) => Promise<void> }) {
  const [quantity, setQuantity] = useState(1)
  return <section className="sale-card" aria-label={e.item.name}>
    <div className="sale-card__item"><ItemArt item={e.item} size={44} /><div><h3>{e.item.name}</h3><small>В суме: {e.quantity} · {e.item.level_required ? `уровень ${e.item.level_required}` : ''}</small></div></div>
    <p>{modList(e.item.modifiers).map(m => `${m.label} ${m.text}`).join(' · ')}</p>
    {e.block ? <p className="note">{e.block}</p> : <>
      <p>{silverText(e.price)} за штуку</p>
      <label className="sale-card__quantity">Количество
        <input aria-label={`Количество: ${e.item.name}`} type="number" inputMode="numeric" min={1} max={e.quantity} value={quantity}
          onChange={event => setQuantity(Math.max(1, Math.min(e.quantity, Math.trunc(Number(event.target.value)) || 1)))} />
      </label>
      <p><b>Вы получите: {silverText(e.price * quantity)}</b></p>
      <ConfirmInPlace key={quantity} question={`Продать «${e.item.name}» ×${quantity} за ${silverText(e.price * quantity)}? Вещь исчезнет из сумы.`} yes="Продать" no="Отмена" onConfirm={() => onSell(quantity)}>
        {ask => <PlankButton onClick={ask}>Продать · {silverText(e.price * quantity)}</PlankButton>}
      </ConfirmInPlace>
    </>}
  </section>
}
